var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Verify',{ref:"verify",attrs:{"activate":true},on:{"set-auth-state":_vm.setAuthState}})}
var staticRenderFns = []

export { render, staticRenderFns }